import {
  HELVETICA_REGULAR,
  GEORGIA,
  HELVETICA_NEUE_BOLD,
  HELVETICA_NEUE_CONDENSED_BOLD,
  HELVETICA_NEUE_MEDIUM,
} from './fonts';
import * as colors from './colors';
import { IS_NATIVE } from '@r3l/common';

const gs = (n) => `hsl(0, 0%, ${n}%)`;

export const lh = 1.4;

const c = {
  text: gs(0),
  black: gs(0),
  background: gs(100),
  white: gs(100),
  blue: '#0000ff',
  grey: gs(50),
  lightGrey: gs(87),
  lightGreyBg: gs(98),
  lightBorder: gs(85),
  textOverlay: gs(100),
  shadowBorder: gs(70),
  twitterBlue: colors.twitterBlue,
  uniswap: colors.uniswap,
};

export const theme = {
  initialColorModeName: 'light',
  useLocalStorage: false,
  useBodyStyles: true,
  useCustomProperties: false,

  colors: {
    ...c,
    ...colors.colors,

    modes: {
      light: {
        ...c,
        ...colors.colors,
      },
      dark: {
        text: gs(100),
        black: gs(100),
        background: gs(8),
        white: gs(8),

        blue: '#0088ff',
        lightGrey: gs(13),
        lightGreyBg: gs(5),
        lightBorder: gs(20),
        textOverlay: gs(100),
        shadowBorder: gs(30),
        ...colors.colors,
      },
    },
  },
  cursor: {
    ...(!IS_NATIVE ? { userSelect: 'none', cursor: 'pointer' } : {}),
  },
  buttons: {
    shadow: {
      boxShadow: '0 2px 6px hsl(240,0%,70%);',
    },
  },
  borders: {
    default: {
      borderColor: 'lightBorder',
      borderWidth: 1,
    },
    navBorder: {
      // border: '0px solid lightBorder',
      // borderBottomColor: 'lightBorder',
      borderColor: 'lightBorder',
    },
    input: {
      borderStyle: 'solid',
      borderColor: 'lightBorder',
      borderWidth: 1,
      ':focus': {
        borderColor: 'blue',
      },
      outline: 'none !important',
    },
    popupBorder: {
      boxShadow: `0px 0px 0px .5px ${c.shadowBorder}, 0 0px 20px -10px grey;`,
    },
    shadowBorderBottom: {
      boxShadow: `0px .5px 0px 0px ${c.shadowBorder};`,
    },
  },
  fonts: {
    body: HELVETICA_REGULAR,
    serif: GEORGIA,
    title: HELVETICA_NEUE_CONDENSED_BOLD,
    heading: HELVETICA_NEUE_BOLD,
    link: HELVETICA_NEUE_MEDIUM,
  },
  lineHeights: [8, 12 * 1.5, 14 * 1.5, 20 * 1.4, 24 * 1.4, 36 * 1.3, 42 * 1.3, 50 * 1.3],
  breakpoints: ['740px'], // important this must match dripsy default breaks (see the dripsy patch)
  space: [0, 8, 16, 24, 32, 40, 48, 54, 64, 72, 80, 88, 96],
  sizes: [0, 12, 14, 16, 24, 32, 40, 48, 54, 64, 72, 80, 88, 96],
  fontSizes: [8, 12, 14, 20, 24, 36, 42, 50],
  styles: {
    root: {
      color: 'black',
      background: 'white',
    },
    h1: {
      variant: 'text.title',
    },
    h2: {
      variant: 'text.heading',
    },
    p: {
      variant: 'text.commentText',
    },
  },
  input: {},
  text: {
    body: {
      fontSize: 2,
      lineHeight: 2,
      fontFamily: 'body',
      color: 'black',
    },
    number: {
      fontFamily: 'title',
      fontSize: 2,
      lineHeight: 2,
      color: 'black',
    },
    bigNumber: {
      fontFamily: 'title',
      fontSize: 3,
      lineHeight: 3,
      color: 'black',
    },
    smallGrey: {
      fontSize: 1,
      lineHeight: 1,
      fontFamily: 'body',
      color: 'grey',
    },
    smallBlack: {
      fontSize: 1,
      lineHeight: 1,
      fontFamily: 'body',
      color: 'black',
    },
    commentText: {
      fontFamily: 'serif',
      fontSize: 2,
      lineHeight: 2,
      color: 'black',
    },
    heading: {
      fontFamily: 'heading',
      fontSize: 3,
      lineHeight: 3,
      color: 'black',
    },
    title: {
      fontFamily: 'title',
      fontSize: 4,
      lineHeight: 3,
      color: 'black',
    },
    link: {
      fontFamily: 'link',
      fontSize: 1,
      lineHeight: 1,
      color: 'grey',
      // textDecoration: 'underline',
    },
    altLink: {
      variant: 'text.link',
      textDecorationLine: 'underline',
    },
    communityLink: {
      fontFamily: 'body',
      fontSize: 2,
      lineHeight: 2,
      color: 'grey',
    },
    highlight: {
      fontFamily: 'serif',
      fontStyle: 'italic',
      color: 'block',
      fontSize: 3,
      lineHeight: 3,
    },
    CTALink: {
      fontFamily: 'body',
      fontSize: 1,
      lineHeight: 1,
      color: 'blue',
    },
    buttonText: {
      fontFamily: 'link',
      fontSize: 1,
      lineHeight: 1,
      color: 'white',
    },
  },
};
